import React, * as react from 'react'
import styled from 'styled-components'
import * as jotoTypes from "../api/joto-types";
import * as joto from "../api/joto";
import * as jotoui from "../joto-ui-api";
import {shallowEqual, useSelector} from "react-redux";

export interface LikeCountState {
    likeCount: number
}

export interface LikeCountProps {
    path : jotoTypes.ProjectPath
    fnlike?: (projectPath: jotoTypes.ProjectPath, like: boolean) => void
}

type StateToLikeCountState = (state : jotoui.JotoUIState) => LikeCountState;
type ProjectPathToStateToLikeCountState = (p : jotoTypes.ProjectPath) => StateToLikeCountState;

const LikeCount_mapStateToComponentState : ProjectPathToStateToLikeCountState = (p : jotoTypes.ProjectPath) : StateToLikeCountState => {

    // noinspection UnnecessaryLocalVariableJS
    const fn : StateToLikeCountState = (state : jotoui.JotoUIState) => {
        const projects : jotoTypes.Project[] = joto.projectArrayFromStoreAndPathArray(state.globalProjectList.store, [p]);
        return {
            likeCount : projects && projects[0] && projects[0].likeCount
        }
    };

    return fn;
};

export const LikeCount : react.FunctionComponent<LikeCountProps> = (props) => {
    const {likeCount} = useSelector(LikeCount_mapStateToComponentState(props.path), shallowEqual);
    return (<p className="like-count">{likeCount}</p>)
}; //<Circle></Circle>

const size = 30;

// noinspection JSUnusedLocalSymbols
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Circle = styled.i`
  position: absolute;
  top: 0;
  right: 0;
  font-style: normal;
  text-align: center;
  height: ${size}px;
  width: ${size}px;
  line-height: ${size}px;
  border-radius: ${size / 2}px;
  border: 1px solid #dddddd;
  background: #eeeeee;`;
